import axios from 'axios';

const defaultConfig = () => ({
  token: false,
  apiVersion: false,
  baseURL: '',
  locale: false,
});

export default (config = defaultConfig) => (store) => {
  store.$axios = axios.create();

  store.$axios.defaults.authenticated = true;

  store.$axios.interceptors.request.use(
    (request) => {
      const {
        token, apiVersion, baseURL, locale,
      } = config();

      request.baseURL = baseURL;

      if (request.authenticated) {
        request.headers.Authorization = `Bearer ${token}`;
      }

      if (apiVersion) {
        request.headers['x-api-version'] = apiVersion;
      }

      if (locale) {
        request.headers['x-api-locale'] = locale;
      }

      // Do something before request is sent
      return request;
    },
    error =>
      // Do something with request error
      Promise.reject(error),
  );

  store.$axios.interceptors.response.use(
    response => (response.data && response.data.data) || response.data || response,
    // Do something with response data

    error =>
      // Do something with response error
      Promise.reject(error.response.data),
  );

  store.$api = store.$axios;
};
